import { render, staticRenderFns } from "./PlanSelector.vue?vue&type=template&id=2fe1482b&scoped=true&"
import script from "./PlanSelector.vue?vue&type=script&lang=js&"
export * from "./PlanSelector.vue?vue&type=script&lang=js&"
import style0 from "./PlanSelector.vue?vue&type=style&index=0&id=2fe1482b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1482b",
  null
  
)

export default component.exports